import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import MDButton from "components/MDButton";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface Props {
  title: string;
  children: React.ReactNode;
  open: boolean;
  handleClose: () => void;
  titleButton?: string;
  action?: (...arg: any) => void;
}

export default function FullScreenDialog({
  children,
  title,
  titleButton,
  open,
  handleClose,
}: Props): JSX.Element {
  return (
    <React.Fragment>
      {titleButton && (
        <MDButton
          onClick={handleClose}
          variant="gradient"
          color="info"
          sx={{ height: "100%" }}
        >
          {titleButton}
        </MDButton>
      )}

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            maxWidth: "100%",
            m: 0,
          },
        }}
      >
        <AppBar position="sticky" color="default" elevation={1}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {title}
            </Typography>
            <Button autoFocus onClick={handleClose}>
              Fechar
            </Button>
          </Toolbar>
        </AppBar>

        <Box
          sx={{
            flex: 1,
            width: "100%",
            minHeight: 0,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </Box>
      </Dialog>
    </React.Fragment>
  );
}

FullScreenDialog.defaultProps = {
  titleButton: "",
};
